import { useMemo, useState, useCallback } from "react";
import * as anchor from "@project-serum/anchor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithubSquare,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";

import styled from "styled-components";
import {
  Snackbar,
  Grid,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  TextField,
  Button,
  Tooltip,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Alert from "@material-ui/lab/Alert";
import { PublicKey } from "@solana/web3.js";
import { useWallet } from "@solana/wallet-adapter-react";
import { WalletDialogButton } from "@solana/wallet-adapter-material-ui";
import getMeta from "./services/getMetaFromCmId";
import {
  awaitTransactionSignatureConfirmation,
  CandyMachineAccount,
  CANDY_MACHINE_PROGRAM,
  getCandyMachineState,
  mintOneToken,
  updateCandyMachineSettings,
  mintMultipleTokens,
} from "./candy-machine";
import { AlertState } from "./utils";
import { Header } from "./Header";
import { MintButton } from "./MintButton";
import { MetadataFromCM } from "./components/MetadataFromCM";
import { SingleNFTmain } from "./components/SingleNFTmain";
import { GatewayProvider } from "@civic/solana-gateway-react";
import { MintLayout } from "@solana/spl-token";
import { Link, animateScroll as scroll } from "react-scroll";
const ConnectButton = styled(WalletDialogButton)`
  width: 100%;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #550041 0%, #e1694c 100%);
  color: white;
  font-size: 16px;
  font-weight: bold;
`;
export const CMButton = styled(Button)`
  width: 100%;
  height: 60px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: linear-gradient(180deg, #550041 0%, #e1694c 100%);
  color: white;
  font-size: 16px;
  font-weight: bold;
`;
const MintContainer = styled.div``; // add your owns styles here

export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}
interface SingleMetadata {
  name: string;
  link: string;
}
let data: Array<SingleMetadata>;
const Home = (props: HomeProps) => {
  const [isToken, setIsToken] = useState(true);
  const [wlDecimals, setWlDecimals] = useState<any>();
  const [metadata, setMetadata] = useState<Array<SingleMetadata>>();
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [cmAddress, setCmAddress] = useState("");
  const [firstCreatorAddress, setFirstCreatorAddress] = useState("");
  const [rpcAddress, setRpcAddress] = useState<string>("");
  const [candyMachine, setCandyMachine] = useState<CandyMachineAccount>();
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const rpcUrl = props.rpcHost;
  const wallet = useWallet();

  function sleep(milliseconds: number) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  const handleCmAddressSubmit = async (e: any) => {
    e.preventDefault();
    let connection = new anchor.web3.Connection(rpcAddress);
    let currentCm = new anchor.web3.PublicKey(cmAddress);
    let wallet = new anchor.Wallet(new anchor.web3.Keypair());
    let newWallet;

    if (!anchorWallet) {
      newWallet = wallet;
    } else {
      newWallet = anchorWallet;
    }
    try {
      const cndy = await getCandyMachineState(newWallet, currentCm, connection);
      const utf8Encode = new TextEncoder();
      const temp = await PublicKey.findProgramAddress(
        [
          utf8Encode.encode("candy_machine"),
          new PublicKey(cmAddress).toBytes(),
        ],
        new PublicKey("cndy3Z4yapfJBmL3ShUp5exZKqR3z33thTzeNMm2gRZ")
      );
      if (cndy.state.whitelistMintSettings?.mint) {
        const mintAccount = await connection.getAccountInfo(
          cndy.state.whitelistMintSettings?.mint
        );
        const newData = await connection.getParsedAccountInfo(
          cndy.state.whitelistMintSettings?.mint
        );
        //@ts-ignore
        // console.log(newData.value?.data.parsed.info.decimals);
        try {
          if (mintAccount?.data.length !== MintLayout.span) {
            setIsToken(false);
          }
          //@ts-ignore
          setWlDecimals(newData.value?.data.parsed.info.decimals.toString());
        } catch (error) {
          console.log("poop");
        }
      }
      setFirstCreatorAddress(temp[0].toString());
      setCandyMachine(cndy);
      data = await getMeta(cmAddress, rpcAddress);
      setMetadata(data);
    } catch (e) {
      console.log("There was a problem fetching Candy Machine state");
      console.log(e);
    }
    console.log(`🤑The CM address: ${cmAddress}`);
  };
  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const refreshCandyMachineState = async () => {
    let connection = new anchor.web3.Connection(rpcAddress);
    let currentCm = new anchor.web3.PublicKey(cmAddress);
    let wallet = new anchor.Wallet(new anchor.web3.Keypair());
    let newWallet;

    if (!anchorWallet) {
      newWallet = wallet;
    } else {
      newWallet = anchorWallet;
    }
    try {
      const cndy = await getCandyMachineState(newWallet, currentCm, connection);

      setCandyMachine(cndy);
    } catch (e) {
      console.log("There was a problem fetching Candy Machine state");
      console.log(e);
    }
    console.log(`🤑The CM address: ${cmAddress}`);
  };

  const onMint = async (count: number) => {
    try {
      setIsUserMinting(true);
      document.getElementById("#identity")?.click();
      let mintTxId;
      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        if (count === 1) {
          mintTxId = (await mintOneToken(candyMachine, wallet.publicKey))[0];
        } else {
          mintTxId = (
            await mintMultipleTokens(candyMachine, wallet.publicKey, count)
          )[0];
        }
        let status: any = { err: true };
        if (mintTxId) {
          status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            true
          );
        }

        if (status && !status.err) {
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
          sleep(10000);
          refreshCandyMachineState();
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (!error.message) {
          message = "Transaction Timeout! Please try again.";
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setIsUserMinting(false);
    }
  };
  /*  const onUpdate = async () => {
    try {
      setIsUserMinting(true);

      if (wallet.connected && candyMachine?.program && wallet.publicKey) {
        const newSettings = {
          itemsAvailable: new anchor.BN(candyMachine.state.itemsAvailable),
          uuid: candyMachine.state.uuid,
          symbol: candyMachine.state.symbol,
          sellerFeeBasisPoints: candyMachine.state.sellerFeeBasisPoints,
          isMutable: candyMachine.state.isMutable,
          maxSupply: new anchor.BN(0),
          retainAuthority: true,
          gatekeeper: candyMachine.state.gatekeeper,
          goLiveDate: candyMachine.state.goLiveDate,
          endSettings: candyMachine.state.endSettings,
          price: candyMachine.state.price,
          whitelistMintSettings: candyMachine.state.whitelistMintSettings,
          hiddenSettings: candyMachine.state.hiddenSettings,
          creators: candyMachine.state.creators,
        };
        if (!anchorWallet) {
          return;
        }
        let connection = new anchor.web3.Connection(rpcAddress);
        let currentCm = new anchor.web3.PublicKey(cmAddress);

        const mintTxId: any = await updateCandyMachineSettings(
          anchorWallet,
          currentCm,
          connection,
          newSettings,
          candyMachine.state.treasury,
          candyMachine.state.tokenMint
        );

        let status: any = { err: true };
        if (mintTxId) {
          status = await awaitTransactionSignatureConfirmation(
            mintTxId,
            props.txTimeout,
            props.connection,
            true
          );
        }

        if (status && !status.err) {
          setAlertState({
            open: true,
            message: "Congratulations! Mint succeeded!",
            severity: "success",
          });
        } else {
          setAlertState({
            open: true,
            message: "Mint failed! Please try again!",
            severity: "error",
          });
        }
      }
    } catch (error: any) {
      console.log(error);
      console.log(error.msg);
      console.log(error.message);
      let message = error.msg || "Minting failed! Please try again!";
      if (!error.msg) {
        if (!error.message) {
          message = "Transaction Timeout! Please try again.";
        } else if (error.message.indexOf("0x137")) {
          message = `SOLD OUT!`;
        } else if (error.message.indexOf("0x135")) {
          message = `Insufficient funds to mint. Please fund your wallet.`;
        }
      } else {
        if (error.code === 311) {
          message = `SOLD OUT!`;
          window.location.reload();
        } else if (error.code === 312) {
          message = `Minting period hasn't started yet.`;
        }
      }

      setAlertState({
        open: true,
        message,
        severity: "error",
      });
    } finally {
      setIsUserMinting(false);
    }
  }; */
  const handleChange = (event: any) => {
    setRpcAddress(event.target.value);
  };
  const handleCmAddressChange = (event: any) => {
    setCmAddress(event.target.value);
    console.log(event.target.value);
  };

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      direction="row"
    >
      <Grid item xs={12} sm={12}>
        <div id="header" style={{ textAlign: "center" }}>
          <h1 className="gradientText">Candy Machine v2 debug tool</h1>
          <h3 className="gradientText">by Halaprix & GD</h3>
          <h4>Additional resources:</h4>
          <a
            href="https://hackmd.io/@halaprix/S1W4vc9CY"
            target="_blank"
            rel="noreferrer"
          >
            <h3>CANDY MACHINE TIPS'N'TRICKS</h3>
          </a>
          <a
            href="https://hackmd.io/@halaprix/S1W4vc9CY#1-I-need-a-frontend-for-my-candy-machine"
            target="_blank"
            rel="noreferrer"
          >
            <h3>GET MINT PAGE TEMPLATE</h3>
          </a>
          <a
            href="https://soltools.vercel.app/"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "underline!important" }}
          >
            <h3>NEW CANDY MACHINE SCANNER</h3>
          </a>
          <h4 className="gradientText">
            <a
              href="https://www.twitter.com/halaprix"
              className="twitter social"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faTwitterSquare} size="2x" />
            </a>

            <a
              href="https://github.com/halaprix"
              className="github social"
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faGithubSquare} size="2x" />
            </a>
          </h4>
        </div>
        <br />
        <Snackbar
          open={alertState.open}
          autoHideDuration={6000}
          onClose={() => setAlertState({ ...alertState, open: false })}
        >
          <Alert
            onClose={() => setAlertState({ ...alertState, open: false })}
            severity={alertState.severity}
          >
            {alertState.message}
          </Alert>
        </Snackbar>
        <br />{" "}
      </Grid>{" "}
      <Grid item xs={12} sm={7} md={3} style={{ margin: "30px" }}>
        <Paper
          style={{
            padding: 0,
            backgroundColor: "rgba(56, 4, 40, 0.9)",
            borderRadius: 6,
            boxShadow: "2px 4px 10px rgba(0,0,0,0.5)",
          }}
        >
          {" "}
          <section className="terminal__bar">
            <div className="bar__buttons">
              <button className="bar__button bar__button--exit">
                &#10005;
              </button>
              <button className="bar__button">&#9472;</button>
              <button className="bar__button">&#9723;</button>
            </div>
            <p className="bar__user">input@ubuntu: ~</p>
          </section>
          <div
            style={{
              padding: 24,
            }}
          >
            <FormControl fullWidth>
              <TextField
                required
                id="standard-required"
                label="CM address (required)"
                defaultValue="GR67BPra1KV3jEmLH9dKaoiFnNQTWV6yRcxLbukjS8sG"
                value={cmAddress}
                onChange={handleCmAddressChange}
                margin="dense"
              />
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="rpcAddress">Select network.</InputLabel>
              <Select
                defaultValue={
                  "https://qn-devnet.solana.fm/"
                }
                labelId="rpcAddress"
                id="rpcAddress-select"
                value={rpcAddress}
                label="RpcAddress"
                onChange={handleChange}
                variant="filled"
                margin="dense"
              >
                <MenuItem
                  value={"https://qn-devnet.solana.fm/"}
                >
                  devnet
                </MenuItem>
                <MenuItem value={"https://ssc-dao.genesysgo.net/"}>
                  mainnet
                </MenuItem>
              </Select>

              <>
                <Tooltip
                  title={
                    !cmAddress || !rpcAddress
                      ? "Set CM address and select network!"
                      : "Click to get the CM config and mint button"
                  }
                >
                  <span>
                    {" "}
                    <Link to="terminalScroll">
                      {" "}
                      <CMButton
                        onClick={handleCmAddressSubmit}
                        disabled={!cmAddress || !rpcAddress}
                        style={
                          !cmAddress || !rpcAddress
                            ? { pointerEvents: "none" }
                            : {}
                        }
                      >
                        Set CM{" "}
                      </CMButton>{" "}
                    </Link>
                  </span>
                </Tooltip>
                <MetadataFromCM
                  cmAddress={cmAddress}
                  disabled={!cmAddress || !rpcAddress}
                  rpcAddress={rpcAddress}
                  metadata={metadata ? metadata : []}
                  setMetadata={setMetadata}
                />
              </>
            </FormControl>
          </div>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={7} md={3} style={{ margin: "30px" }}>
        <Paper
          style={{
            padding: 0,
            backgroundColor: "rgba(56, 4, 40, 0.9)",
            borderRadius: 6,
            boxShadow: "2px 4px 10px rgba(0,0,0,0.5)",
          }}
        >
          <section className="terminal__bar">
            <div className="bar__buttons">
              <button className="bar__button bar__button--exit">
                &#10005;
              </button>
              <button className="bar__button">&#9472;</button>
              <button className="bar__button">&#9723;</button>
            </div>
            <p className="bar__user">mint@ubuntu: ~</p>
          </section>
          <div
            style={{
              padding: 24,
            }}
          >
            {!wallet.connected ? (
              <ConnectButton>Connect Wallet</ConnectButton>
            ) : (
              <>
                <Header candyMachine={candyMachine} />
                <MintContainer>
                  {candyMachine?.state.isActive &&
                  candyMachine?.state.gatekeeper &&
                  wallet.publicKey &&
                  wallet.signTransaction ? (
                    <GatewayProvider
                      wallet={{
                        publicKey:
                          wallet.publicKey ||
                          new PublicKey(CANDY_MACHINE_PROGRAM),
                        //@ts-ignore
                        signTransaction: wallet.signTransaction,
                      }}
                      gatekeeperNetwork={
                        candyMachine?.state?.gatekeeper?.gatekeeperNetwork
                      }
                      clusterUrl={rpcUrl}
                      options={{ autoShowModal: false }}
                    >
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isUserMinting}
                        onMint={() => onMint(1)}
                        count={1}
                      />
                    </GatewayProvider>
                  ) : (
                    <>
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isUserMinting}
                        onMint={() => onMint(1)}
                        count={1}
                      />
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isUserMinting}
                        onMint={() => onMint(5)}
                        count={5}
                      />
                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isUserMinting}
                        onMint={() => onMint(10)}
                        count={10}
                      />

                      <MintButton
                        candyMachine={candyMachine}
                        isMinting={isUserMinting}
                        onMint={() => onMint(20)}
                        count={20}
                      />
                    </>
                  )}
                </MintContainer>
              </>
            )}
          </div>
        </Paper>
      </Grid>
      {metadata && metadata.length > 0 && (
        <Grid item xs={12} sm={7} md={3} style={{ margin: "30px" }}>
          <SingleNFTmain item={metadata[0]} />
        </Grid>
      )}
      <Grid item xs={12} sm={12} style={{ margin: "30px" }} id="terminalScroll">
        <Paper
          style={{
            padding: 0,
            backgroundColor: "rgba(56, 4, 40, 0.9)",
            borderRadius: 6,
            boxShadow: "2px 4px 10px rgba(0,0,0,0.5)",
          }}
        >
          {
            <div className="terminal">
              <section className="terminal__bar">
                <div className="bar__buttons">
                  <button className="bar__button bar__button--exit">
                    &#10005;
                  </button>
                  <button className="bar__button">&#9472;</button>
                  <button className="bar__button">&#9723;</button>
                </div>
                <p className="bar__user">metaplex@ubuntu: ~</p>
              </section>

              <section className="terminal__body">
                <div className="terminal__prompt">
                  <span className="terminal__prompt--user">
                    metaplex@ubuntu:
                  </span>
                  <span className="terminal__prompt--location">~</span>
                  <span className="terminal__prompt--bling">$</span>
                  <span className="terminal__prompt--bling">
                    {" "}
                    ts-node ~\js\packages\cli\src\candy-machine-v2-cli.ts show
                    -k .\key.json -e mainnet-beta --rpc-url
                    https://ssc-dao.genesysgo.net/
                  </span>
                </div>

                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    rpcAddress:{" "}
                    <b style={{ color: "#79a411", textDecoration: "none" }}>
                      {rpcAddress}{" "}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    {"  "}cmAddress:{" "}
                    <a
                      href={
                        cmAddress && candyMachine
                          ? rpcAddress == "https://ssc-dao.genesysgo.net/"
                            ? `https://solscan.io/account/${cmAddress}`
                            : `https://solscan.io/account/${cmAddress}?cluster=devnet`
                          : "#"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b style={{ color: "#79a411" }}>{cmAddress} </b>
                    </a>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    CM authority:{" "}
                    <a
                      href={
                        candyMachine && candyMachine.authority
                          ? rpcAddress == "https://ssc-dao.genesysgo.net/"
                            ? `https://solscan.io/account/${candyMachine.authority.toBase58()}`
                            : `https://solscan.io/account/${candyMachine.authority.toBase58()}?cluster=devnet`
                          : "#"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b style={{ color: "#886e04" }}>
                        {candyMachine?.authority.toBase58()}{" "}
                        <span style={{ color: "#f7cc00" }}>
                          {candyMachine &&
                          candyMachine.authority.toBase58() ==
                            anchorWallet?.publicKey.toBase58()
                            ? "That's you"
                            : ""}
                        </span>
                      </b>
                    </a>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    {/* <button onClick={()=> onUpdate()}>asdad</button> */}
                    derived 1st creator:{" "}
                    <a
                      href={
                        candyMachine && firstCreatorAddress
                          ? rpcAddress == "https://ssc-dao.genesysgo.net/"
                            ? `https://solscan.io/account/${firstCreatorAddress}`
                            : `https://solscan.io/account/${firstCreatorAddress}?cluster=devnet`
                          : "#"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b style={{ color: "#886e04" }}>{firstCreatorAddress}</b>
                    </a>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    itemsAvailable:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.itemsAvailable
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    itemsRedeemed:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine ? candyMachine.state.itemsRedeemed : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    itemsRemaining:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.itemsRemaining
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    treasury:{" "}
                    <a
                      href={
                        candyMachine && candyMachine.state.treasury?.toString()
                          ? rpcAddress == "https://ssc-dao.genesysgo.net/"
                            ? `https://solscan.io/account/${candyMachine.state.treasury?.toString()}`
                            : `https://solscan.io/account/${candyMachine.state.treasury?.toString()}?cluster=devnet`
                          : "#"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b style={{ color: "#886e04" }}>
                        {candyMachine
                          ? candyMachine.state.treasury?.toString()
                          : "null"}
                        <span style={{ color: "#f7cc00" }}>
                          {candyMachine &&
                          candyMachine.state.treasury.toBase58() ==
                            anchorWallet?.publicKey.toBase58()
                            ? " That's you"
                            : ""}
                        </span>
                      </b>
                    </a>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    seller fee:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? `${candyMachine.state.sellerFeeBasisPoints.toString()} (${(
                            candyMachine.state.sellerFeeBasisPoints / 100
                          ).toString()}%)`
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    tokenMint:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.tokenMint?.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    isSoldOut:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.isSoldOut?.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    isActive:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.isActive?.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    isPresale:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.isPresale?.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    goLiveDate:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine && candyMachine.state.goLiveDate
                        ? new Date(
                            candyMachine.state.goLiveDate?.toNumber() * 1000
                          ).toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling">
                    {"   "}price:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine && candyMachine.state.price
                        ? `${candyMachine.state.price?.toString()} (${(
                            candyMachine.state.price.toNumber() / 1000000000
                          ).toString()} SOL)`
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level1 ">
                    gatekeeper:{" "}
                    {/* <b>{candyMachine.state.gatekeeper?.toString()}</b> */}
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2 ">
                    expireOnUse:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.gatekeeper?.expireOnUse.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2 ">
                    gatekeeperNetwork:<b> </b>
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.gatekeeper?.gatekeeperNetwork.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                {/*     <div className="terminal__prompt">
              <span className="terminal__prompt--bling">
                endSettings: <b>{candyMachine ? candyMachine.state.endSettings?.toString()}</b>
              </span>
            </div> */}
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level1 ">
                    WhitelistMintSettings:
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2 ">
                    mode:
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.whitelistMintSettings?.mode
                            .burnEveryTime
                          ? "burnEveryTime"
                          : candyMachine.state.whitelistMintSettings?.mode
                              .neverBurn
                          ? "neverBurn"
                          : "null"
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2 ">
                    mint:{" "}
                    <a
                      href={
                        candyMachine &&
                        candyMachine.state.whitelistMintSettings?.mint.toString()
                          ? rpcAddress == "https://ssc-dao.genesysgo.net/"
                            ? `https://solscan.io/token/${candyMachine.state.whitelistMintSettings?.mint.toString()}`
                            : `https://solscan.io/token/${candyMachine.state.whitelistMintSettings?.mint.toString()}?cluster=devnet`
                          : "#"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <b style={{ color: "#886e04" }}>
                        {candyMachine
                          ? candyMachine.state.whitelistMintSettings?.mint.toString()
                          : "null"}{" "}
                        <span style={{ color: "#d0002a" }}>
                          {candyMachine &&
                          anchorWallet &&
                          candyMachine.state.whitelistMintSettings?.mint.toBase58() ===
                            anchorWallet?.publicKey.toBase58()
                            ? "That's your address - it should be the address of your WL token!"
                            : ""}
                        </span>{" "}
                        <span style={{ color: "yellow" }}>
                          {!isToken
                            ? "This token is not a token address WTF"
                            : ""}
                        </span>
                      </b>
                    </a>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    token decimals :<b> </b>
                    <b style={{ color: "#886e04" }}>
                      {wlDecimals ? (
                        wlDecimals.toString() === "0" ? (
                          <span
                            style={{ color: "green" }}
                          >{`${wlDecimals.toString()} all good here!`}</span>
                        ) : (
                          <a href="https://hackmd.io/@halaprix/S1W4vc9CY#18-The-Candy-machine-is-not-burning-my-WL-tokens">
                            <span
                              style={{ color: "red" }}
                            >{`${wlDecimals.toString()} oh no! Click here!`}</span>
                          </a>
                        )
                      ) : (
                        "null"
                      )}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    presale:<b> </b>
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.whitelistMintSettings?.presale.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    discountPrice:<b> </b>
                    <b style={{ color: "#886e04" }}>
                      {candyMachine &&
                      candyMachine.state.whitelistMintSettings?.discountPrice
                        ? `${candyMachine.state.whitelistMintSettings?.discountPrice?.toString()} (${(
                            candyMachine.state.whitelistMintSettings?.discountPrice?.toNumber() /
                            1000000000
                          ).toString()} SOL)`
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level1">
                    hiddenSettings:
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    name:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.hiddenSettings?.name.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    uri:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.hiddenSettings?.uri.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    hash:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.hiddenSettings?.hash.toString()
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level1">
                    endSettings:
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    type:{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.endSettings?.endSettingType.date
                          ? "date"
                          : candyMachine.state.endSettings?.endSettingType
                              .amount
                          ? "amount"
                          : "null"
                        : "null"}
                    </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    number / date :{" "}
                    <b style={{ color: "#886e04" }}>
                      {candyMachine
                        ? candyMachine.state.endSettings?.endSettingType.date
                          ? new Date(
                              candyMachine.state.endSettings?.number.toNumber() *
                                1000
                            ).toString()
                          : candyMachine.state.endSettings?.endSettingType
                              .amount
                          ? candyMachine.state.endSettings?.number.toString()
                          : "null"
                        : "null"}
                    </b>
                  </span>
                </div>

                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level1">
                    creators (from CM config, not from metadata) : <br></br>
                    <b> </b>
                  </span>
                </div>
                <div className="terminal__prompt">
                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                    {candyMachine
                      ? candyMachine.state.creators.map(
                          (item: any, index: number) => {
                            return (
                              <>
                                <div className="terminal__prompt" key={index}>
                                  <span className="terminal__prompt--bling terminal__prompt--padding_level2">
                                    {item.address.toString()}{" "}
                                    <b style={{ color: "#886e04" }}>
                                      {item.share} %
                                    </b>{" "}
                                    {item.verified
                                      ? "verified"
                                      : "not verified"}{" "}
                                  </span>
                                </div>
                              </>
                            );
                          }
                        )
                      : "null"}
                  </span>
                </div>

                <div className="terminal__prompt">
                  <span className="terminal__prompt--user">
                    metaplex@ubuntu:
                  </span>
                  <span className="terminal__prompt--location">~</span>
                  <span className="terminal__prompt--bling">$</span>
                  <span className="terminal__prompt--cursor"></span>
                </div>
              </section>
            </div>
          }
        </Paper>
      </Grid>{" "}
    </Grid>
  );
};

export default Home;

{
  /*  <MaterialTable
        style={{ backgroundColor: "#3f092b" }}
        columns={[
          { title: "Property", field: "property" },
          { title: "Value", field: "value" },
        ]}
        data={[
          { property: "Candy Machine Address", value: cmAddress },
          {
            property: "Candy Machine Authority",
            value: candyMachine?.authority.toString(),
          },
          {
            property: "Items Available",
            value: candyMachine?.state.itemsAvailable.toString(),
          },{
            property: "Items Redeemed",
            value: candyMachine?.state.itemsRedeemed.toString(),
          },{
            property: "Items Remaining",
            value: candyMachine?.state.itemsRemaining.toString(),
          },{
            property: "Treasury",
            value: candyMachine?.state.treasury.toString(),
          },{
            property: "Token Mint",
            value: candyMachine?.state.tokenMint?.toString(),
          },{
            property: "Is Sold Out ?",
            value: candyMachine?.state.isSoldOut.toString(),
          },{
            property: "Is Active ?",
            value: candyMachine?.state.isActive.toString(),
          },{
            property: "Is Presale ?",
            value: candyMachine?.state.isPresale.toString(),
          },{
            property: "Go Live Date",
            value: candyMachine?.state.goLiveDate.toString(),
          },{
            property: "Price",
            value: candyMachine?.state.price.toString(),
          },{
            property: "Gatekeeper : Network",
            value: candyMachine?.state.gatekeeper?.gatekeeperNetwork.toString(),
          },{
            property: "Gatekeeper : Expire on Use",
            value: candyMachine?.state.gatekeeper?.expireOnUse.toString(),
          },{
            property: "WhitelistMintSettings : Mode",
            value: candyMachine
            ? candyMachine.state.whitelistMintSettings?.mode
                .burnEveryTime
              ? "burnEveryTime"
              : candyMachine.state.whitelistMintSettings?.mode
                  .neverBurn
              ? "neverBurn"
              : "null"
            : "null",
          },{
            property: "WhitelistMintSettings : Mint address (SPL token)",
            value: candyMachine?.state.whitelistMintSettings?.mint.toString(),
          },{
            property: "WhitelistMintSettings : Presale",
            value: candyMachine?.state.whitelistMintSettings?.presale.toString(),
          },{
            property: "HiddenSettings : Name",
            value: candyMachine?.state.hiddenSettings?.name.toString(),
          },{
            property: "HiddenSettings : URI",
            value: candyMachine?.state.hiddenSettings?.uri.toString(),
          },{
            property: "HiddenSettings : hash",
            value: candyMachine?.state.hiddenSettings?.hash.toString(),
          },{
            property: "EndSettings : type",
            value: candyMachine
            ? candyMachine.state.endSettings?.endSettingType.date
              ? new Date(
                  candyMachine.state.endSettings?.number.toNumber() *
                    1000
                ).toString()
              : candyMachine.state.endSettings?.endSettingType.amount
              ? candyMachine.state.endSettings?.number.toString()
              : "null"
            : "null",
          },{
            property: "HiddenSettings : number / date",
            value: candyMachine
            ? candyMachine.state.endSettings?.endSettingType.date
              ? new Date(
                  candyMachine.state.endSettings?.number.toNumber() *
                    1000
                ).toString()
              : candyMachine.state.endSettings?.endSettingType.amount
              ? candyMachine.state.endSettings?.number.toString()
              : "null"
            : "null",
          },
        ]}
        title="CM"
      /> */
}
